import '../../Page/DissertationPrivacyPolicy.css'

function PrivacyPolicyBanner() {
  return (
    <>
    <section className="dissertationPrivacyPolicySectionStartHere">
        <div className="container-fluid dissertationPrivacyPolicyBannerImageSection">
            <div className="row justify-content-center">
                <div className="col-md-7 dissertationPrivacyPolicyBannerHeadingAndPara">
                    <h2 className='privacyPolicyHeading'>PRIVACY POLICY</h2>
                    <p className='dissertationPrivacyPolicyFirstPara'>
                    This privacy policy document outlines the types of personal information that is received and collected by WriteMyDissertationForMe. 
                    </p>
                    <p className='dissertationPrivacyPolicySecondPara'>
                    Last Updated: August 01, 2026<br />
                    Effective as of August 01, 2027
                    </p>
                </div>
                <div className="col-md-5"></div>
            </div>
        </div>
    </section>
    </>
  )
}

export default PrivacyPolicyBanner